import anime from 'animejs';
/** Source: https://stackoverflow.com/a/13067009 */
// eslint-disable-next-line func-names
((document, history, location, header) => {
  const HISTORY_SUPPORT = !!(history && history.pushState);
  if (!header) return;

  const headerRect = header.getBoundingClientRect();
  const anchorScrolls = {
    ANCHOR_REGEX: /^#[^ ]+$/,
    OFFSET_HEIGHT_PX: headerRect.height || 116,

    /**
     * Establish events, and fix initial scroll position if a hash is provided.
     */
    init() {
      // this.scrollToCurrent();
      window.addEventListener('hashchange', this.scrollToCurrent.bind(this));
      document.body.addEventListener('click', this.delegateAnchors.bind(this));
    },

    /**
     * Return the offset amount to deduct from the normal scroll position.
     * Modify as appropriate to allow for dynamic calculations
     */
    getFixedOffset() {
      return this.OFFSET_HEIGHT_PX;
    },

    /**
     * If the provided href is an anchor which resolves to an element on the
     * page, scroll to it.
     * @param  {String} href
     * @return {Boolean} - Was the href an anchor.
     */
    scrollIfAnchor(href, pushToHistory) {
      let rect;
      let anchorOffset;

      if (!this.ANCHOR_REGEX.test(href)) {
        return false;
      }

      const scrollElement = document.getElementById(href.slice(1));
      const match = scrollElement && scrollElement.closest('section');

      if (match) {
        rect = match.getBoundingClientRect();
        anchorOffset = window.pageYOffset + rect.top - this.getFixedOffset();
        const scrollCoords = {
          y: window.pageYOffset,
        };
        anime({
          targets: scrollCoords,
          y: anchorOffset,
          duration: 700,
          easing: 'easeInOutCubic',
          update: () => window.scroll(window.pageXOffset, scrollCoords.y),
        });

        // window.scrollTo(window.pageXOffset, anchorOffset);

        // Add the state to history as-per normal anchor links
        if (HISTORY_SUPPORT && pushToHistory) {
          history.pushState({}, document.title, location.pathname + href);
        }
      }

      return !!match;
    },

    /**
     * Attempt to scroll to the current location's hash.
     */
    scrollToCurrent() {
      this.scrollIfAnchor(window.location.hash);
    },

    /**
     * If the click event's target was an anchor, fix the scroll position.
     */
    delegateAnchors(e) {
      const elem = e.target;

      if (
        elem.nodeName === 'A' &&
        this.scrollIfAnchor(elem.getAttribute('href'), true)
      ) {
        e.preventDefault();
      }
    },
  };

  window.addEventListener(
    'DOMContentLoaded',
    anchorScrolls.init.bind(anchorScrolls)
  );
})(
  window.document,
  window.history,
  window.location,
  window.document.getElementById('page-header')
);



// WEBPACK FOOTER //
// ./src/scripts/lib/scrollOffset.js